export default {
  changeIdentifyCode: ({ commit }, payload) => {
    commit('CHANGE_IDENTIFYCODE', payload)
  },
  login: ({ commit }, payload) => {
    commit('LOGIN', payload)
  },
  logout: ({ commit },) => {
    commit('LOGOUT')
  },
  setUnreadCount: ({ commit }, payload) => {
    commit('SET_UNREAD_COUNT', payload)
  }
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js